/**
 * Tab metadata for the admin Campaign page.
 *
 * Kept out of `CampaignTabNav.tsx` so the component file exports only a component — exporting
 * helpers alongside it breaks Fast Refresh, and both the page and its tests need these without
 * pulling in the component.
 *
 * Admin access is deliberately NOT here: managing admins is its own top-level destination
 * (`/admin-access`, in the header after Contact), not a section of Campaign.
 */

export type CampaignTabId = 'cdmo' | 'sponsor' | 'history';

export interface CampaignTab {
  id: CampaignTabId;
  label: string;
}

export const CAMPAIGN_TABS: readonly CampaignTab[] = Object.freeze([
  { id: 'cdmo', label: 'CDMO claim' },
  { id: 'sponsor', label: 'Sponsor invites' },
  { id: 'history', label: 'History' },
]);
